import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { ThemePreventionSantePublique } from '../models/preventionSantePublique/themePreventionSantePublique';

const resource = 'ThemesActionPreventionSantePublique'

export default class ThemesPreventionSantePubliqueRessources {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string, actifOnly?: boolean) : Promise<PaginatedList<ThemePreventionSantePublique>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
